'use strict';

var MarketSeasonAndOutlierService = function MarketSeasonAndOutlierService(restangular) {
  function preparePayload(market, spos, data) {
    var m = market.split('-');
    return {
      carrier: data.carrier,
      origin: m[0],
      destination: m[1],
      significantPOS: spos,
      classGroup: data.productGroup,
      departureDate: data.d1.toISOString(),
      dowGroup: data.dowGroup,
      isMappedOutlier: data.isMappedOutlier,
      isRegularOutlier: data.isRegularOutlier,
      season: data.season
    };
  }
  function updateMarketOutlier(payload) {
    return restangular.one('ancillary').one('marketSeasonAndOutlier').one('bulk').customPUT({
      value: payload
    });
  }
  return {
    preparePayload: preparePayload,
    updateMarketOutlier: updateMarketOutlier
  };
};
MarketSeasonAndOutlierService.$inject = ['Restangular'];
module.exports = MarketSeasonAndOutlierService;